"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _spacing2 = _interopRequireDefault(require("../../../modifiers/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container",
  componentId: "sc-11lr2zn-0"
})(["box-sizing:border-box;display:block;margin-left:auto;margin-right:auto;padding-left:", ";padding-right:", ";position:relative;width:100%;", ";"], (0, _rem.default)(_spacing.default.base), (0, _rem.default)(_spacing.default.base), _spacing2.default);

Container.displayName = 'Grid.Container';
var _default = Container;
exports.default = _default;